import React, { useEffect, useState } from 'react'
import DataTable from '../DataTable/DataTable'
import { ChartName, ChartRowObject } from '../../types/data'
import axios from 'axios'
import { getChartData } from '../../resources/api-constants'
import { getRequestHeader } from '../../utility/functions'

interface Props {
    token?: string
    needsToken?: boolean
    chartTimeSpan: ChartName
    hasMoreThanTenElements?: boolean
    hideTvChart?: boolean
}

const TablesContainer: React.FC<Props> = (props) => {
    const [radioData, setRadioData] = useState<ChartRowObject[]>([])
    const [tvData, setTvData] = useState<ChartRowObject[]>([])

    const fetchChartsData = async () => {
        try {
            const radioCharts = await axios
                .get(getChartData('audio', props.chartTimeSpan, !!props.token), getRequestHeader(props.token || ''))
                .then((response) => response.data)
            if (radioCharts) setRadioData(radioCharts)
            if (props.hideTvChart) return

            const tvCharts = await axios
                .get(getChartData('video', props.chartTimeSpan, !!props.token), getRequestHeader(props.token || ''))
                .then((response) => response.data)
            if (tvCharts) setTvData(tvCharts)
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        if (props.needsToken && !props.token) return
        void fetchChartsData()
    }, [props.token, props.needsToken])

    return (
        <>
            <div className="tables-container tablet-wrap">
                {radioData.length ? (
                    <div className="tables-container__column">
                        <span className="section-title">Top radio</span>
                        <DataTable data={radioData} isPaginated={props.hasMoreThanTenElements} />
                    </div>
                ) : null}
                {tvData.length && !props.hideTvChart ? (
                    <div className="tables-container__column">
                        <span className="section-title">Top visual radio</span>
                        <DataTable data={tvData} isPaginated={props.hasMoreThanTenElements} />
                    </div>
                ) : null}
            </div>
        </>
    )
}
export default TablesContainer
